module.exports = __webpack_public_path__ + "static/media/CurriculumMathExamBigIcon.38f90b55.svg";